<!-- 小程序公共页 -->
<template>
  <a-layout>
    <a-layout-content>
      <a-page-header
        :title="this.$route.meta.title"
        :sub-title="this.$route.meta.subTitle"
        @back="this.goBack"
        class="vd-gl-header-warp"
      >
        <template slot="footer">
          <a-tabs :default-active-key="this.$route.path" @change="changePane">
            <a-tab-pane key="/tik/detail/data" tab="账号数据"></a-tab-pane>
          </a-tabs>
        </template>
      </a-page-header>
      <div class="vd-gl-content">
        <router-view />
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      id: null,
    };
  },
  created() {
    /* 获取参数*/
    this.id = this.$route.query.id;
    if (!this.id) {
      this.$message.error({ content: "访问参数错误" });
      // 链接回跳
      this.$router.push({ path: "/tik/setting", replace: true });
      return false;
    }
  },
  methods: {
    // modal
    // 跳转
    changePane(value) {
      // 判断参数是否正确
      if (this.id) {
        this.$router.replace({ path: value, query: { id: this.id } });
      } else {
        this.$message.error({ content: "访问参数错误" });
        // 链接回跳
        this.$router.replace({ path: "/tik/setting", replace: true });
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
